import { render, staticRenderFns } from "./sparepartsupdate.vue?vue&type=template&id=10b2cf53&"
import script from "./sparepartsupdate.vue?vue&type=script&lang=js&"
export * from "./sparepartsupdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports